import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchSofEntries } from "../../apis/sof";

export const getSof = createAsyncThunk(
  "sof/getSof",
  async (
    { csofIds }: { csofIds: string[] },
    { rejectWithValue }
  ) => {
    try {
      const entriesArrays = await Promise.all(
        csofIds.map((csofId) => fetchSofEntries(csofId))
      );
      const allEntries = entriesArrays.flat();
      return {
        data: allEntries,
        total: allEntries.length,
      };
    } catch (error: any) {
      console.log("error->", error);
      return rejectWithValue(error.message);
    }
  }
);